export enum MailProvider {
    Exchange
}

